import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import GeometryFactory from '../GeometryFactory';
import ArrayList from '../../../../../java/util/ArrayList';
var GeometryCollectionMapper = /*#__PURE__*/function () {
  function GeometryCollectionMapper() {
    _classCallCheck(this, GeometryCollectionMapper);
    GeometryCollectionMapper.constructor_.apply(this, arguments);
  }
  _createClass(GeometryCollectionMapper, [{
    key: "map",
    value: function map(gc) {
      var mapped = new ArrayList();
      for (var i = 0; i < gc.getNumGeometries(); i++) {
        var g = this._mapOp.map(gc.getGeometryN(i));
        if (!g.isEmpty()) mapped.add(g);
      }
      return gc.getFactory().createGeometryCollection(GeometryFactory.toGeometryArray(mapped));
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._mapOp = null;
      var mapOp = arguments[0];
      this._mapOp = mapOp;
    }
  }, {
    key: "map",
    value: function map(gc, op) {
      var mapper = new GeometryCollectionMapper(op);
      return mapper.map(gc);
    }
  }]);
  return GeometryCollectionMapper;
}();
export { GeometryCollectionMapper as default };